import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { EditPage } from '../edit_page/EditPage';
import {
	budgetsRestCrudThunksForBuyer,
	budgetsRestCrudThunksForSupplier,
} from '../../thunks/budget_thunks';
import BudgetForm from '../budget_form/BudgetForm';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { withUserType } from '../withUserType';
import { ROLE_TYPES } from '../../utils/DataConstants';

const queryString = require('qs');

class EditBudgetPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
		this.state = {
			backLinkParams: '',
		};
	}
	componentDidMount() {
		const { getBudget, match, location, userType } = this.props;
		const budgetId = match.params.id;
		getBudget(budgetId).then((budget) => {
			//Setup back button persistence
			let searchString = location.search;
			if (searchString[0] === '?') {
				searchString = searchString.slice(1);
			}
			const queryParams = queryString.parse(searchString);
			if (queryParams.backlinkParams) {
				const { tab, pathName, ...otherParams } = queryString.parse(queryParams.backlinkParams);
				const finalPath = pathName || `/${userType}/workOrders/detail/${budgetId}/details`;
				this.setState({
					backLinkParams: new URLSearchParams(queryParams).toString(),
				});
			}
		});
	}

	render() {
		const { history, budget, fetching, userType } = this.props;

		//noinspection TypeScriptUnresolvedVariable
		return fetching ? (
			<PageLoadingPlaceholder />
		) : (
			[
				<EditPage
					title="Edit Budget"
					formComponentProps={{
						formData: budget,
						isEditForm: true,
						onSuccess: (rec) =>
							history.push(
								`/${userType}/budgets/detail/${rec.id}/details`.concat(
									'?',
									this.state.backLinkParams
								)
							),
					}}
					fetching={fetching}
					FormComponent={BudgetForm}
				/>,
			]
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		history: ownProps.history,
		budget: state.budgets.detail,
		fetching: state.budgets.fetching,
		match: ownProps.match,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	getBudget: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? budgetsRestCrudThunksForSupplier.readOne(id)
				: budgetsRestCrudThunksForBuyer.readOne(id)
		),
});

export default withUserType(
	withRouter<any, any>(connect(mapStateToProps, mapDispatchToProps)(EditBudgetPage as any)) as any
);
